import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '../../core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '../../core/runtime/surfaces/surface.schema.slots';

export const creatorSurface = {
  id: SurfaceType.Creator,
  saveStrategy: 'submit',
  defaultFieldMode: 'edit',
  viewStatePersistence: 'none',
  sectionLayout: { columns: 2, maxWidth: 1600, sectionBorder: false, columnDivider: true },
  // Create dialogs hand their title bar to the Creator so a stepped Creator's step header sits beside the title.
  ownsDialogChrome: true,
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.Creator],
} as const satisfies SurfaceTypeDefinition<SurfaceType.Creator>;
